import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { fpColors } from "../../../theme/fpTheme.ts";

const Header = () => {
  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: "space-between",
        maxWidth: { sm: "100%", md: "1700px" },
        position: "relative",
        pb: 1,
        "&:after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "1px",
          background: `linear-gradient(90deg, transparent 0%, ${fpColors.fpgreen} 50%, transparent 100%)`,
        },
      }}
      spacing={2}
    >
      <Box>
        <Typography
          variant="h4"
          fontWeight={600}
          sx={{
            color: fpColors.fpdarkblue,
            letterSpacing: "0.5px",
          }}
        >
          Overview
        </Typography>
        {/* <Typography variant="subtitle2" sx={{ color: fpColors.fpgrey }}>
          Dashboard • Insights • Analytics
        </Typography> */}
      </Box>

      {/* Future component for date picker or other controls */}
    </Stack>
  );
};

export default Header;
